
import Vue from 'vue';
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

export const i18n = new VueI18n({
  locale: 'ptBR', // set default locale
  fallbackLocale: navigator.language.replace('-', "") || 'ptBR', // set fallback locale
  messages: {}, // empty because it will dynamically populated
  silentTranslationWarn: true, 
  pluralizationRules: {
    // /**
    //  * @param choice {number} a choice index given by the input to $tc: `$tc('path.to.rule', choiceIndex)`
    //  * @param choicesLength {number} an overall amount of available choices
    //  * @returns a final choice index to select plural word by
    //  */
    // 'en': function(choice, choicesLength) {
    //   // this === VueI18n instance
    //   if (choice === 0) {
    //     return 0;
    //   }
    //   return choice === 1 ? choice : 2;
    // }
  }
})


// WEBPACK FOOTER //
// ./src/service/i18n.js